import { createAction, props } from "@ngrx/store";

export const setSimulationLoadData = createAction(
  '[Simulation Load] Set Simulation Process',
  props<{ data: any }>()
);